import { useEffect } from "react";
import { useSelector } from "react-redux";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:4000/api";

const CartSync = () => {
    const token = useSelector((state) => state.user.token);
    const cartItems = useSelector((state) => state.cart.cartItems);

    useEffect(() => {
        if (!token) return;

        const timeout = setTimeout(() => {
            axios
                .put(
                    `${API_URL}/auth/cart`,
                    { items: cartItems },
                    { headers: { Authorization: `Bearer ${token}` } }
                )
                .catch((err) => console.error("Failed to save cart", err));
        }, 800);

        return () => clearTimeout(timeout);
    }, [token, cartItems]);

    return null;
};

export default CartSync;
